export const GPA_CALCULATION_FOUR_DECIMAL_SCALE_FACTOR = 10000;
export const GPA_CALCULATION_TWO_DECIMAL_SCALE_FACTOR = 100;

/**
 * Round the gpa to 2 decimal places, e.g. 3.14159 → 3.14; 2.119 → 2.12
 * @param gpa the calculated gpa
 * @returns the rounded gpa
 */
export const roundGpa = (gpa: number): number =>
  Math.round(gpa * GPA_CALCULATION_TWO_DECIMAL_SCALE_FACTOR) / GPA_CALCULATION_TWO_DECIMAL_SCALE_FACTOR;

/** Render the GPA in a consistent string format of x.yz */
export const renderGpa = (gpa: number): string => roundGpa(gpa).toFixed(2);

interface SumOfCreditsCourse {
  segmentCourse: {
    creditValue: number;
  };
}

/**
 * Calculate the total credit value of a list of courses
 * @param courses the given list of courses
 * @returns the total (summation) of the credit values
 */
export const getSumOfCredits = (courses: SumOfCreditsCourse[]): number => {
  return courses.reduce((runningTotal, course) => runningTotal + course.segmentCourse.creditValue, 0);
};
